__turbopack_context__.v({
  "bottom": "PlasmicLoginFormSecurity-module__-gxOHG__bottom",
  "securityDesktop": "PlasmicLoginFormSecurity-module__-gxOHG__securityDesktop",
  "securityDesktopnoPadding": "PlasmicLoginFormSecurity-module__-gxOHG__securityDesktopnoPadding",
  "securityXs": "PlasmicLoginFormSecurity-module__-gxOHG__securityXs",
  "sm": "PlasmicLoginFormSecurity-module__-gxOHG__sm",
  "sm2": "PlasmicLoginFormSecurity-module__-gxOHG__sm2",
  "smLink": "PlasmicLoginFormSecurity-module__-gxOHG__smLink",
  "smLink2": "PlasmicLoginFormSecurity-module__-gxOHG__smLink2",
  "soc": "PlasmicLoginFormSecurity-module__-gxOHG__soc",
  "soc2": "PlasmicLoginFormSecurity-module__-gxOHG__soc2",
  "socLink": "PlasmicLoginFormSecurity-module__-gxOHG__socLink",
  "socLink2": "PlasmicLoginFormSecurity-module__-gxOHG__socLink2",
  "ssl": "PlasmicLoginFormSecurity-module__-gxOHG__ssl",
  "ssl2": "PlasmicLoginFormSecurity-module__-gxOHG__ssl2",
  "sslLink": "PlasmicLoginFormSecurity-module__-gxOHG__sslLink",
  "sslLink2": "PlasmicLoginFormSecurity-module__-gxOHG__sslLink2",
  "top": "PlasmicLoginFormSecurity-module__-gxOHG__top",
  "truste": "PlasmicLoginFormSecurity-module__-gxOHG__truste",
  "truste2": "PlasmicLoginFormSecurity-module__-gxOHG__truste2",
  "trusteLink": "PlasmicLoginFormSecurity-module__-gxOHG__trusteLink",
  "trusteLink2": "PlasmicLoginFormSecurity-module__-gxOHG__trusteLink2",
  "wrapper": "PlasmicLoginFormSecurity-module__-gxOHG__wrapper",
});
